import { render, staticRenderFns } from "./msg_filter_dialog.vue?vue&type=template&id=506e7382&scoped=true"
import script from "./msg_filter_dialog.vue?vue&type=script&lang=js"
export * from "./msg_filter_dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506e7382",
  null
  
)

export default component.exports